import { StreamData } from 'types/streamData'
import WidgetType from 'enums/WidgetType'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const missDataResolver: FieldResolver = (metadata: Metadata) => {
  const widgetType = metadata.getWidgetType()
  if (!widgetType) {
    return {} as StreamData
  }

  const isTweet = metadata.isTweet()
  const noRetweets = metadata.getRetweets() === '--'
  const noReplies = metadata.getReplies() === '--'
  const noImpressions = metadata.getImpressions() === '--'
  const noShares = metadata.getShares() === '--'

  let missData
  switch (widgetType) {
    case WidgetType.SOCIAL_WEB_POPULAR_POSTS:
      missData = isTweet && (noRetweets || noReplies || noImpressions)
      break

    case WidgetType.SOCIAL_WEB_POPULAR_LINKS:
    case WidgetType.AUDIENCE_POPULAR_LINKS:
      missData = noImpressions || noShares
      break

    default:
  }

  return { missData } as StreamData
}

export default missDataResolver
